import { CSS_COLORS } from 'consts/consts';
import { closeBtn as close } from 'icons/close';
import { left } from 'icons/left';
import './chatSettingsHeader.scss';

export const ChatSettingsHeaderTemplate = (model) => {
	const { title } = model;

	/* html */
	const backBtn = `
		<div class="engt-chat-settings-back engt-tab-selectable" tabindex="0" style="visibility: hidden" onkeydown="ENGT_CHAT.onEnterPress()">${left(
			CSS_COLORS.THEME_TEXT_COLOR
		)}</div>
	`;

	/* html */
	const closeBtn = `
		<div 
			role="button" 
			tabindex="0"
			class="engt-chat-settings-close engt-tab-selectable" 
			onkeydown="ENGT_CHAT.onEnterPress()"
			>
			${close(CSS_COLORS.THEME_TEXT_COLOR)}
		</div>
	`;

	/* html */
	const html = `
		${backBtn}
		<span>${title}</span>
		${closeBtn}
    `;

	return html;
};
